import "./topBar.scss";
import UserAlarms from "../../UserAlarms";

export interface UserAlarmDialogProps {
    onClose: () => void;
    fullWidth: boolean;
}

function UserAlarmsDialog(props: UserAlarmDialogProps) {
    return (
        <>
            <div
                className="offClick"
                onClick={props.onClose}
            />
            <div className="user-Alarms-dialog">
                <UserAlarms  onClose={props.onClose}  />
            </div>
        </>
    );
}

export default UserAlarmsDialog;
